/* OEMUPGRADES home v2: hero story loop (before -> install -> after), 2.5D tilt, upgrade-path tabs. No dependencies. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initStory(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var phases = ['before', 'install', 'after'];
    var durs = { before: 5200, install: 3200, after: 6600 };
    var btns = root.querySelectorAll('[data-step]');
    var pauseBtn = root.querySelector('[data-pause]');
    var i = 0, timer = null, paused = false, visible = true, left = 0, startedAt = 0;

    function paint() {
      var p = phases[i];
      root.setAttribute('data-phase', p);
      btns.forEach(function (b, k) {
        b.classList.toggle('is-on', k === i);
        b.classList.toggle('is-done', k < i);
        b.setAttribute('aria-current', k === i ? 'step' : 'false');
        b.style.setProperty('--dur', durs[phases[k]] + 'ms');
        var s = b.querySelector('span');
        if (s && k === i) { s.style.animation = 'none'; void s.offsetWidth; s.style.animation = ''; }
      });
    }
    function schedule(ms) {
      clearTimeout(timer);
      left = ms; startedAt = Date.now();
      if (paused || !visible) return;
      timer = setTimeout(function () { i = (i + 1) % phases.length; paint(); schedule(durs[phases[i]]); }, ms);
    }
    function go(k) { i = k; paint(); schedule(durs[phases[i]]); }
    function setPaused(v) {
      paused = v;
      if (v) { clearTimeout(timer); left = Math.max(0, left - (Date.now() - startedAt)); root.setAttribute('data-paused', ''); }
      else { root.removeAttribute('data-paused'); schedule(left || durs[phases[i]]); }
      if (pauseBtn) { pauseBtn.textContent = v ? '▶' : '❚❚'; pauseBtn.setAttribute('aria-label', v ? 'Play' : 'Pause'); }
    }
    btns.forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
    if (pauseBtn) pauseBtn.addEventListener('click', function () { setPaused(!paused); });

    paint();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          visible = e.isIntersecting;
          if (visible && !paused) schedule(left || durs[phases[i]]); else clearTimeout(timer);
        });
      }, { threshold: 0.25 }).observe(root);
    }
    schedule(durs[phases[i]]);

    /* 2.5D tilt on pointer devices */
    var stage = root.querySelector('[data-stage]');
    if (stage && !reduce && window.matchMedia('(hover: hover)').matches) {
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        stage.style.setProperty('--ry', (x * 9).toFixed(2) + 'deg');
        stage.style.setProperty('--rx', (-y * 7).toFixed(2) + 'deg');
      });
      stage.addEventListener('pointerleave', function () { stage.style.setProperty('--ry', '0deg'); stage.style.setProperty('--rx', '0deg'); });
    }
  }

  function initTabs(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var tabs = root.querySelectorAll('[data-filter]');
    var cards = root.querySelectorAll('[data-from]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var f = t.getAttribute('data-filter');
        tabs.forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
        cards.forEach(function (c) { c.hidden = !(f === 'all' || (' ' + c.getAttribute('data-from') + ' ').indexOf(' ' + f + ' ') > -1); });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-oem-story]').forEach(initStory);
    document.querySelectorAll('[data-oem-paths]').forEach(initTabs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();